import * as React from 'react'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import { Typography, Box } from '@mui/material'
import ListItems from './ListItems'
import { useTranslation } from 'react-i18next'

type CustomDrawerProps = {
  open: boolean
  toggleDrawer: () => void
  handleChangeView: (view: string) => void
  setOpen: (b: boolean) => void
}

const drawerWidth: number = 310

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  ...(window.innerWidth > 900 && {
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      backgroundColor: '#474747',
      padding: '18px',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,
        padding: '8px 0px 0px 0px',
        [theme.breakpoints.up('sm')]: {
          width: 0,
        },
      }),
    },
  }),
  ...(window.innerWidth < 900 && {
    '& .MuiDrawer-paper': {
      display: 'flex',
      justifyContent: 'space-around',
      whiteSpace: 'nowrap',
      backgroundColor: '#474747',
      padding: '0px 8px',
      height: '100px',
      marginTop: '70px',
      width: '100%',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,
        padding: '8px 0px 0px 0px',
        [theme.breakpoints.up('sm')]: {
          width: 0,
        },
      }),
    },
  }),
}))

const CustomDrawer = (props: CustomDrawerProps) => {
  const { t } = useTranslation()
  const handleClick = (type: string) => {
    props.handleChangeView(type)
  }

  return (
    <>
      <Drawer variant="permanent" open={props.open}>
        <ListItems handleClick={handleClick} isOpen={props.open} setOpen={props.setOpen} />
        {/* Los enlaces de privacidad y cookies salen del menu porque el diseno no
            los lleva. Las rutas (ROUTE_PRIVACY_POLICY, ROUTE_COOKIES_POLICY)
            siguen activas y se llega a ellas por URL y desde el pie del login,
            pero conviene confirmar con legal que basta con eso. */}

        {/* Pie del menu: linea separadora de lado a lado y el copyright debajo,
            como en el diseno. */}
        {props.open && (
          <Box
            sx={{
              // Linea mas tenue y el texto pegado a ella, como en el diseno: con
              // py 1.75 quedaba un hueco arriba y otro abajo que hacian el pie
              // mucho mas alto de lo que deberia.
              borderTop: '1px solid rgba(255, 255, 255, 0.09)',
              // El paper del drawer lleva 18px de padding, asi que sin estos
              // margenes negativos la linea se queda a 18px de cada borde en
              // vez de cruzar el menu de lado a lado como en el diseno.
              mx: '-18px',
              px: '18px',
              pt: 1,
              pb: 0.75,
              // Se come el padding inferior del paper para que el pie llegue al
              // fondo y no quede ese trozo suelto debajo.
              mb: '-18px',
            }}
          >
            <Typography
              sx={{
                color: '#8f8f8f',
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 400,
              }}
            >
              {t('copyright')}
            </Typography>
          </Box>
        )}
      </Drawer>
    </>
  )
}

export default CustomDrawer
